<template>
  <transition name="modal">
    <div class="modal-mask" v-show="show">
      <div class="modal-container">
        <div class="modal-header">
          <h3>Resetar Senha</h3>
        </div>
        <div class="modal-body">
          <div class='row'>
           <div class="col-sm-12">
            <div :class="{'form-group': true}">
              <label for="senha">Nova Senha</label>
              <input class="form-control" ref="senha" type="password" v-model="password">
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">

       <div class="text-right" style="float:right">
         <button class="btn btn-default" @click="()=>{this.$emit('close')}">
          Fechar
        </button>
        <button class="btn btn-primary" @click="enviaSenha()">
          Atualizar
        </button>
      </div>
    </div>
  </div>

</div>
</transition>
</template>


<script>

  export default {
    props: ['show'],
    data:() => ({
      password: ''
    }),

    methods: {
      enviaSenha: function () {
        this.$emit('updateSenha', this.password);
        this.password = '';
        this.$emit('close');
      },
    },
    watch: {
      show: function(val) {
        if (val) {
          this.$nextTick(() => this.$refs.senha.focus());
        }
      }
    }
  }

</script>

<style scoped>
  * {
    box-sizing: border-box;
  }

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
  }

  .modal-container {
    width: 50%;
    margin: 40px auto 0;
    padding: 10px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #333;
  }

  .modal-body {
    margin: 10px 0;
  }

  .text-right {
    text-align: right;
  }

  .form-label {
    display: block;
    margin-bottom: 1em;
  }

  .form-label > .form-control {
    margin-top: 0.5em;
  }

  .form-control {
    display: block;
    width: 100%;
    padding: 0.5em 1em;
    line-height: 1.5;
    border: 1px solid #ddd;
  }

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

 .modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal{
  display: block !important; /* I added this to see the modal, you don't need this */
}

/* Important part */
.modal-dialog{
  overflow-y: initial !important
}
.modal-body{
  height: 120px;
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// ResetPassword.vue?52ba05da